import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import { CMSTypes } from "../../../../../Helpers/CMSHelper";
import { getLanguage } from "../../../../../Helpers/LanguageHelper";
import { SnackbarManager } from "../../../../../Helpers/SnackbarManager/SnackbarManager";
import { StorageHelper } from "../../../../../Helpers/StorageHelper";
import { useQuery } from "react-query";
import axios, { AxiosResponse } from "axios";

export const PrivacyPolicyRoute = () => {
  const [languageChangeSignal, setLanguageChangeSignal] = useState(0);

  useEffect(() => {
    const handleLocalStorageUpdated = () => {
      setLanguageChangeSignal((prev) => prev + 1); // This will trigger re-evaluation
    };

    window.addEventListener("localStorageUpdated", handleLocalStorageUpdated);

    return () => {
      window.removeEventListener(
        "localStorageUpdated",
        handleLocalStorageUpdated
      );
    };
  }, []);
  const countryId = useMemo(() => {
    let country = new StorageHelper().getFacadeCountry();
    if (country == null) {
      SnackbarManager.Instance.addError(getLanguage(469, "Unknown error"));
      return "";
    }

    return country.Id;
  }, []);

  const language = useMemo(() => {
    const localization = new StorageHelper().getFacadeLocalization();
    return localization?.language;
  }, [languageChangeSignal]);

  const { data: response, isLoading } = useQuery<AxiosResponse<any>>(
    ["privacy-policy-content", countryId, language],
    () => {
      return axios.get<any>(`/api/cms/getdraftbycountryandtype`, {
        headers: {
          "Content-type": "application/json",
          authToken: new StorageHelper().getAccessToken(),
        },
        withCredentials: true,
        params: {
          country: countryId,
          type: CMSTypes.PrivacyPolicy,
          language,
        },
      });
    }
  );

  if (isLoading) return <></>;

  return (
    <div style={{ margin: "10px" }}>
      <div
        dangerouslySetInnerHTML={{ __html: response?.data?.Text ?? <p></p> }}
      ></div>
    </div>
  );
};
